
    //........................................Globals.........................................................

import lookups from "./modules/lookups";
import security from "./modules/security";

   //........................................employeesManagement.........................................................

import employees from "./modules/employees";
import employeeHealth from "./modules/employeeHealth";
import employeeCourses from "./modules/employeeCourses";
import employeeQualifications from "./modules/employeeQualifications";

   //........................................employeeOperations.........................................................

import directorsAppointments from "./modules/directorsAppointments";
import employeeLeaves from "./modules/employeeLeaves";
import assignments from "./modules/assignments";
import employeeTransfers from "./modules/employeeTransfers";
import employeeDelegations from "./modules/employeeDelegations";
import bonuses from "./modules/bonuses";
import degreeDelegnations from "./modules/degreeDelegnations";
import notifications from "./modules/notifications";
import promotions from "./modules/promotions";
import complaints from "./modules/complaints";
import employeesTermination from "./modules/employeesTermination";
import retirements from "./modules/retirements";
import grievances from "./modules/grievances";
import employeesCorrection from "./modules/employeesCorrection";

//........................................settings.........................................................
import administrations from "./modules/administrations";
import departments from "./modules/departments";
import jobGrades from "./modules/jobGrades";
import attendanceDevices from "./modules/attendanceDevices";
import attendanceReports from "./modules/attendanceReports";
import workSchedules from "./modules/workSchedules";
import holidays from "./modules/holidays";
import organization from "./modules/organization";
import users from "./modules/users";
import units from "./modules/units";
//........................................Lists.........................................................
import banks from "./modules/banks";
import jobGroups from "./modules/jobGroups";
import jobs from "./modules/jobs";
import specialties from "./modules/specialties";
import universities from "./modules/universities";
import localities from "./modules/localities";

import reports from "./modules/reports";
import dashboard from "./modules/dashboard";
import search from "./modules/search";

export default {
    // Globals
    lookups,
    security,

   // employeesManagement
    employees,
    employeeHealth,
    employeeCourses,
    employeeQualifications,


   // employeeOperations
    directorsAppointments,
    employeeLeaves,
    assignments,
    employeeTransfers,
    employeeDelegations,
    bonuses,
    degreeDelegnations,
    notifications,
    promotions,
    complaints,
    employeesTermination,
    retirements,
    grievances,
    employeesCorrection,

    // settings
    administrations,
    departments,
    jobGrades,
    users,
    units,
    attendanceDevices,
    attendanceReports,
    workSchedules,
    holidays,
    organization,

    // Lists
    banks,
    jobGroups,
    jobs,
    specialties,
    universities,
    localities,
    
    reports,
    dashboard,
    search
};